const indexes = {
  assets: process.env.FUNDAMENTEI_ENV === "production" ? "assets" : "assets_qa",
  issuers: process.env.FUNDAMENTEI_ENV === "production" ? "issuers" : "issuers",
};

export default indexes;
